import { Component } from '@angular/core';

/**
 * Generated class for the MyLayoutStdComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'my-layout-std',
  templateUrl: 'my-layout-std.html'
})
export class MyLayoutStdComponent {

  text: string;

  constructor() {
    console.log('Hello MyLayoutStdComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/my-layout-std/my-layout-std.ts